/**
 * Header fresh labels — brise glaciale séquentielle chip→chip.
 * Pause si document.hidden. reduced-motion = pas d'animation (CSS).
 */
(function () {
  'use strict';

  var reducedMotion =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init() {
    var root = document.querySelector('.canicule-header-fresh-labels');
    if (!root || root.dataset.breezeReady) return;
    root.dataset.breezeReady = '1';

    var chips = Array.prototype.slice.call(root.querySelectorAll('[data-fresh-chip]'));
    if (!chips.length || reducedMotion) return;

    var i = 0;
    var timer = null;

    function clearBreeze() {
      chips.forEach(function (chip) {
        chip.classList.remove('is-breeze');
      });
    }

    function pulse() {
      if (document.hidden || window.innerWidth < 990) {
        clearBreeze();
        return;
      }
      clearBreeze();
      var chip = chips[i % chips.length];
      requestAnimationFrame(function () {
        chip.classList.remove('is-breeze');
        requestAnimationFrame(function () {
          chip.classList.add('is-breeze');
        });
      });
      i += 1;
    }

    function start() {
      if (timer) return;
      pulse();
      timer = window.setInterval(pulse, 2200);
    }

    function stop() {
      if (timer) {
        window.clearInterval(timer);
        timer = null;
      }
      clearBreeze();
    }

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop();
      else start();
    });

    window.addEventListener(
      'resize',
      function () {
        if (window.innerWidth < 990) stop();
        else start();
      },
      { passive: true }
    );

    start();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
